/** Original Tavi's Workshop pixel art. Legacy keys preserve saved-course compatibility. */
import { parseSprite, type Sprite } from '../sprite'
export const TILE_SPRITES: Record<string, Sprite> = {
  ground: parseSprite(
    16,
    `
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaw
aaaaaaaaaaaaawwa
aaaaawaaaaaawaaa
aaawwaaaaaaaaaaa
aawaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaawaa
aaaaaaaaaaawwaaa
aaaaaaaaaawaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
`,
  ),
  'ground-top': parseSprite(
    16,
    `
TTTTTTTTTTTTTTTT
GGGGGGGGGGGGGGGG
GGGGGGGGGGGGGGGG
MMMMMMMMMMMMMMMM
aaawwaaaaaaaaaaa
aawaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaawaa
aaaaaaaaaaawwaaa
aaaaaaaaaawaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
aaaaaaaaaaaaaaaa
`,
  ),
  'hard-block': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KaWaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaNNNNNNNNaaaK
KaaaNaaaaaaNaaaK
KaaaNaaaaaaNaaaK
KaaaNaaaaaaNaaaK
KaaaNaaaaaaNaaaK
KaaaNaaaaaaNaaaK
KaaaNaaaaaaNaaaK
KaaaNNNNNNNNaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaKaK
KaaaaaaaaaaaaaaK
KKKKKKKKKKKKKKKK
`,
  ),
  brick: parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KNWNNNNNNNNNOKNK
KNNNNNNNNNNOKNNK
KNNNNNNNNNOKNNNK
KNNNNNNNNOKNNNNK
KNNNNNNNOKNNNNNK
KNNNNNNOKNNNNNNK
KNNNNNOKNNNNNNNK
KNNNNOKNNNNNNNNK
KNNNOKNNNNNNNNNK
KNNOKNNNNNNNNNNK
KNOKNNNNNNNNNNNK
KNKNNNNNNNNNNKNK
KNNNNNNNNNNNNNNK
KKKKKKKKKKKKKKKK
`,
  ),
  'crate-block': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KaWaaaaaaaaaaaaK
KaaaaaaaNaaaaaaK
KaaaaaaNNNaaaaaK
KaaaaaNNTNNaaaaK
KaaaaNNTTTNNaaaK
KaaaNNTTWTTNNaaK
KaaNNTTTTTTTNNaK
KaaaNNTTTTTNNaaK
KaaaaNNTTTNNaaaK
KaaaaaNNTNNaaaaK
KaaaaaaNNNaaaaaK
KaaaaaaaNaaaaKaK
KaaaaaaaaaaaaaaK
KKKKKKKKKKKKKKKK
`,
  ),
  'crate-block-used': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KaWaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaaKKKKKKaaaaK
KaaaaKKKKKKaaaaK
KaaaaKKKKKKaaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaKaK
KaaaaaaaaaaaaaaK
KKKKKKKKKKKKKKKK
`,
  ),
  platform: parseSprite(
    16,
    `
................
................
................
................
................
................
................
................
................
................
KKKKKKKKKKKKKKKK
TTTTTTTTTTTTTTTT
KNONNNNNONNNNNOK
KNNOONNNNOONNNNO
KNNNNONNNNNONNNK
KKKKKKKKKKKKKKKK
`,
  ),
  'slope-left': parseSprite(
    16,
    `
T...............
aT..............
aaT.............
aaaT............
aaaaT...........
aaaaaT..........
aaaaaaT.........
aaaaaaaT........
aaaaaaaaT.......
aaaaaaaaaT......
aaaaaaaaaaT.....
aaaaaaaaaaaT....
aaaaaaaaaaaaT...
aaaaaaaaaaaaaT..
aaaaaaaaaaaaaaT.
aaaaaaaaaaaaaaaT
`,
  ),
  'slope-right': parseSprite(
    16,
    `
...............T
..............Ta
.............Taa
............Taaa
...........Taaaa
..........Taaaaa
.........Taaaaaa
........Taaaaaaa
.......Taaaaaaaa
......Taaaaaaaaa
.....Taaaaaaaaaa
....Taaaaaaaaaaa
...Taaaaaaaaaaaa
..Taaaaaaaaaaaaa
.Taaaaaaaaaaaaaa
Taaaaaaaaaaaaaaa
`,
  ),
  coin: parseSprite(
    16,
    `
................
........K.......
........K.......
.......KWK......
......KTWTK.....
.....KTTWTTK....
....KTTTWTTTK...
...KTTTTWTTTTK..
..KTTTTTWTTTTTK.
...KTTTTWTTTTK..
....KTTTWTTTK...
.....KTTWTTK....
......KTTTK.....
.......KTK......
........K.......
........K.......
`,
  ),
  'pipe-top-left': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KKKKKKKKKKKKKKKK
YYYYYYYYYYYYYYYY
YYYYYYYYYYYYYYYY
aaaaaaaaaaaaaaaa
aTTaaTTaaTTaaTTa
aTTaaTTaaTTaaTTa
aTTaaTTaaTTaaTTa
aaaaaaaaaaaaaaaa
KKKKKKKKKKKKKKKK
KKKKKKKKKKKKKKKK
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
`,
  ),
  'pipe-top-right': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KKKKKKKKKKKKKKKK
YYYYYYYYYYYYYYYY
YYYYYYYYYYYYYYYY
aaaaaaaaaaaaaaaa
aTTaaTTaaTTaaTTa
aTTaaTTaaTTaaTTa
aTTaaTTaaTTaaTTa
aaaaaaaaaaaaaaaa
KKKKKKKKKKKKKKKK
KKKKKKKKKKKKKKKK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
`,
  ),
  'pipe-body-left': parseSprite(
    16,
    `
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
KNNOONNNNNNNNNNN
`,
  ),
  'pipe-body-right': parseSprite(
    16,
    `
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
NNNNNNNNNNNOONNK
`,
  ),
  spike: parseSprite(
    16,
    `
................
................
................
................
................
...K.......K....
...p.......p....
..KpK.....KpK...
..ppp.....ppp...
.KpppK...KpppK..
KpppppK.KpppppK.
.KpppK...KpppK..
..ppp.....ppp...
..KpK.....KpK...
...p.......p....
VVVVVVVVVVVVVVVV
`,
  ),
  'lava-top': parseSprite(
    16,
    `
................
................
ppp...ppp...ppp.
pppppppppppppppp
VVVpppVVVpppVVVp
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVPPPVVVVVPPPVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
VVVVVVVVVVVVVVVV
`,
  ),
  saw: parseSprite(
    16,
    `
................
........w.......
........K.......
...w...KKK...w..
....w.KKVKK.w...
.....KKVVVKK....
....KKVVTVVKK...
...KKVVTTTVVKK..
.wKKVVTTTTTVVKKw
...KKVVTTTVVKK..
....KKVVTVVKK...
.....KKVVVKK....
....w.KKVKK.w...
...w...KKK...w..
........K.......
........w.......
`,
  ),
  spring: parseSprite(
    16,
    `
................
.KKKKKKKKKKKKKK.
.KTTTTTTTTTTTTK.
.KKKKKKKKKKKKKK.
........wwww....
....aaww........
......aaaa......
........wwww....
....aaww........
......aaaa......
........wwww....
....aaww........
......aaaa......
.KKKKKKKKKaaKKK.
.KNNNNNNNNNNNNK.
.KKKKKKKKKKKKKK.
`,
  ),
  'spring-extended': parseSprite(
    16,
    `
................
.KKKKKKKKKKKKKK.
.KTTTTTTTTTTTTK.
.KKKKKKKKKKKKKK.
........wwww....
....aaww........
......aaaa......
........wwww....
....aaww........
......aaaa......
........wwww....
....aaww........
......aaaa......
.KKKKKKKKKaaKKK.
.KNNNNNNNNNNNNK.
.KKKKKKKKKKKKKK.
`,
  ),
  'note-block': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KaWaaaaaaaaaaaaK
KaaaaaaaaaaaaaaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaTTaTTaTTaTTaK
KaaaaaaaaaaaaaaK
KaaaaaaaaaaaaKaK
KaaaaaaaaaaaaaaK
KKKKKKKKKKKKKKKK
`,
  ),
  'onoff-block': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KVWVVVVVVVVVVVVK
KVVVVVVVVVVVVVVK
KVVVKKKKKKKKVVVK
KVVVKTTTWTTKVVVK
KVVVKTTTWTTKVVVK
KVVVKTTTWTTKVVVK
KVVVKTTTWTTKVVVK
KVVVKTTTWTTKVVVK
KVVVKTTTTTTKVVVK
KVVVKKKKKKKKVVVK
KVVVVVVVVVVVVVVK
KVVVVVVVVVVVVKVK
KVVVVVVVVVVVVVVK
KKKKKKKKKKKKKKKK
`,
  ),
  'onoff-block-off': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KVWVVVVVVVVVVVVK
KVVVVVVVVVVVVVVK
KVVVKKKKKKKKVVVK
KVVVKaaaWaaKVVVK
KVVVKaaaWaaKVVVK
KVVVKaaaWaaKVVVK
KVVVKaaaWaaKVVVK
KVVVKaaaWaaKVVVK
KVVVKaaaaaaKVVVK
KVVVKKKKKKKKVVVK
KVVVVVVVVVVVVVVK
KVVVVVVVVVVVVKVK
KVVVVVVVVVVVVVVK
KKKKKKKKKKKKKKKK
`,
  ),
  'moving-platform': parseSprite(
    32,
    `
................................
................................
KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK
TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT
KNONNNNNONNNNNONNNNNONNNNNONNNNK
KNNOONNNNOONNNNOONNNNOONNNNOONNK
KNNNNONNNNNONNNNNONNNNNONNNNNONK
KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK
`,
  ),
  'checkpoint-flag': parseSprite(
    16,
    `
........K.......
.......KKK......
......KKTKK.....
.....KKTTTKK....
....KKTTWTTKK...
..KKTTTTTTTTTKK.
....KKTTTTTKK...
.....KKTTTKK....
......KKTKK.....
......KKKK......
......KNKK......
......KNNK......
......KNNK......
......KNNK......
......KNNK......
......KKKK......
`,
  ),
  'goal-flag': parseSprite(
    16,
    `
........K.......
.......KKK......
......KKPKK.....
.....KKPPPKK....
....KKPPWPPKK...
..KKPPPPPPPPPKK.
....KKPPPPPKK...
.....KKPPPKK....
......KKPKK.....
......KKKK......
......KNKK......
......KNNK......
......KNNK......
......KNNK......
......KNNK......
......KKKK......
`,
  ),
  cannon: parseSprite(
    16,
    `
................
................
................
................
..KKKKKKKKKK....
..KaaaaaaaaK....
..KaaaaaaKKKKKKK
..KaaaaaaKNNNNNK
..KaaaaaaKNTTTTT
..KaaaaaaKNTTTTT
..KaaaaaaKNNNNNK
..KaaaaaaKKKKKKK
..KaaaaaaaaK....
..KaaaaaaaaK....
NNNNNNNNNNNNNN..
NNNNNNNNNNNNNN..
`,
  ),
  'cannon-fire': parseSprite(
    16,
    `
..KKKKKKKKKOOOOO
..KaaaaaaKNOOOOO
..KaaaaaaKNNNNNK
..KaaaaaaKNNNNNK
..KaaaaaaKNNNNNK
..KaaaaaaKKKKKKK
NNNNNNNNNNNNNN..
NNNNNNNNNNNNNN..
`,
  ),
  bridge: parseSprite(
    16,
    `
................
................
................
................
................
................
................
................
................
................
KKKKKKKKKKKKKKKK
TTTTTTTTTTTTTTTT
KNONNNNNONNNNNOK
KNNOONNNNOONNNNO
KNNNNONNNNNONNNK
KKKKKKKKKKKKKKKK
`,
  ),
  vine: parseSprite(
    16,
    `
.......N.N......
.......N.N......
.......TTTT.....
.......N.N......
.......N.N......
.......N.N......
.......N.N......
.......TTTT.....
.......N.N......
.......N.N......
.......N.N......
.......N.N......
.......TTTT.....
.......N.N......
.......N.N......
.......N.N......
`,
  ),
  'ice-block': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KcWccccccccWcccK
KcccccccccWccccK
KccccccccWcccccK
KcccccccWccccccK
KccccccWcccccTcK
KcccccWcccccTccK
KccccWcccccTcccK
KcccWcccccTccccK
KccWcccccTcccccK
KcWcccccTccccccK
KccccccTcccccccK
KcccccTccccccKcK
KccccccccccccccK
KKKKKKKKKKKKKKKK
`,
  ),
  sand: parseSprite(
    16,
    `
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNNNO
NNNNNNNNNNNNNOON
NNNNNONNNNNNONNN
NNNOONNNNNNNNNNN
NNONNNNNNNNNNNNN
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNONN
NNNNNNNNNNNOONNN
NNNNNNNNNNONNNNN
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNNNN
NNNNNNNNNNNNNNNN
`,
  ),
  'hidden-cache': parseSprite(
    16,
    `
KKKKKKKKKKKKKKKK
KwwwwwwwwwwwwwwK
KaWaaaaaaaaaaaaK
KaaaaaaaNaaaaaaK
KaaaaaaNNNaaaaaK
KaaaaaNNTNNaaaaK
KaaaaNNTTTNNaaaK
KaaaNNTTWTTNNaaK
KaaNNTTTTTTTNNaK
KaaaNNTTTTTNNaaK
KaaaaNNTTTNNaaaK
KaaaaaNNTNNaaaaK
KaaaaaaNNNaaaaaK
KaaaaaaaNaaaaKaK
KaaaaaaaaaaaaaaK
KKKKKKKKKKKKKKKK
`,
  ),
  cloud: parseSprite(
    32,
    `
................................
................................
................................
..cccccccccccccccccccccccccc....
.....WWWWWWWWWWWWWWWWWWWWWWWWWW.
................................
................................
.....cccccccccccccccccccccccc...
......WWWWWWWWWWWWWWWWWWWWWW....
................................
................................
........cccccccccccccccccccccc..
.......WWWWWWWWWWWWWWWWWW.......
................................
................................
................................
`,
  ),
  cloud2: parseSprite(
    32,
    `
................................
................................
................................
..cccccccccccccccccccccccccc....
.....WWWWWWWWWWWWWWWWWWWWWWWWWW.
................................
................................
.....cccccccccccccccccccccccc...
......WWWWWWWWWWWWWWWWWWWWWW....
................................
................................
........cccccccccccccccccccccc..
.......WWWWWWWWWWWWWWWWWW.......
................................
................................
................................
`,
  ),
  bush: parseSprite(
    32,
    `
................B...............
................B...............
...............BcB..............
...............BcB..............
..............BBcBB.....C.......
..............BBcBB.....C.......
........V....BBBcBBB...CcC......
.......VVV..BBBBcBBBB.CCcCC.....
......VVcVV.BBBBcBBBBCCCcCCC....
.....VVVcVVBBBBBcBBBCCCCcCCCC...
....VVVVcVVBBBBBcBBBCCCCcCCCC...
...VVVVVcVBBBBBBcBBCCCCCcCCCCC..
..VVVVVVcVBBBBBBcBCCCCCCcCCCCCC.
.VVVVVVVcBBBBBBBcCCCCCCCcCCCCCCC
VVVVVVVVBBBBBBBBCCCCCCCCCCCCCCCC
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
`,
  ),
  'hill-lg': parseSprite(
    48,
    `
................................................
........................B.......................
........................B.......................
........................c.......................
.......................BcB......................
.......................BcB......................
......................BBcBB.....................
......................BBcBB.....................
......................BBcBB.....................
.....................BBBcBBB....................
.....................BBBcBBB........C...........
....................BBBBcBBBB.......C...........
....................BBBBcBBBB......CcC..........
............V.......BBBBcBBBB......CcC..........
............V......BBBBBcBBBBB....CCcCC.........
...........VcV.....BBBBBcBBBBB...CCCcCCC........
..........VVcVV...BBBBBBcBBBBBB..CCCcCCC........
..........VVcVV...BBBBBBcBBBBBB.CCCCcCCCC.......
.........VVVcVVV.BBBBBBBcBBBBBBBCCCCcCCCC.......
........VVVVcVVVVBBBBBBBcBBBBBBCCCCCcCCCCC......
........VVVVcVVVVBBBBBBBcBBBBBCCCCCCcCCCCCC.....
.......VVVVVcVVVBBBBBBBBcBBBBBCCCCCCcCCCCCC.....
......VVVVVVcVVVBBBBBBBBcBBBBCCCCCCCcCCCCCCC....
.....VVVVVVVcVVBBBBBBBBBcBBBBCCCCCCCcCCCCCCC....
.....VVVVVVVcVVBBBBBBBBBcBBBCCCCCCCCcCCCCCCCC...
....VVVVVVVVcVVBBBBBBBBBcBBCCCCCCCCCcCCCCCCCCC..
...VVVVVVVVVcVBBBBBBBBBBcBBCCCCCCCCCcCCCCCCCCC..
...VVVVVVVVVcVBBBBBBBBBBcBCCCCCCCCCCcCCCCCCCCCC.
..VVVVVVVVVVcBBBBBBBBBBBcBCCCCCCCCCCcCCCCCCCCCC.
.VVVVVVVVVVVcBBBBBBBBBBBcCCCCCCCCCCCcCCCCCCCCCCC
VVVVVVVVVVVVBBBBBBBBBBBBCCCCCCCCCCCCCCCCCCCCCCCC
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
`,
  ),
  fence: parseSprite(
    16,
    `
................
................
..KKK.....KKK...
..KTK.....KTK...
..KTK.....KTK...
NNKTKNNNNNKTKNNN
NNKTKNNNNNKTKNNN
..KTK.....KTK...
..KTK.....KTK...
..KTK.....KTK...
..KTK.....KTK...
NNKTKNNNNNKTKNNN
NNKTKNNNNNKTKNNN
..KTK.....KTK...
..KTK.....KTK...
..KKK.....KKK...
`,
  ),
  'water-top': parseSprite(
    16,
    `
................
................
TTT...TTT...TTT.
TTTTTTTTTTTTTTTT
BBBTTTBBBTTTBBBT
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBcccBBBBBcccBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBB
`,
  ),
  'goal-castle': parseSprite(
    64,
    `
................................Y...............................
.................................Y..............................
..................................Y.............................
...................................Y............................
....................................Y...........................
................................K...Y...........................
.........................KKKKKKKKKKKKYKK........................
......................KKKKKKKKKKGKKKKKYKKKK.....................
....................KKKKKGGGGGGGGGGGGGGYKKKKK...................
...................KKKKGGGGGGGGGGGGGGGGGGGKKKK..................
.................KKKKGGGGGGGGGGGGGGGGGGGGGGGKKKK................
................KKKGGGGGGGGGGGGGGGGGGGGGGGGGGGKKK...............
...............KKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKK..............
..............KKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKK.............
..............KKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKK.............
.............KKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKK............
.............KKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKK............
............KKGGGGGGGGGGGGKKKKKKKKKKKKGGGGGGGGGGGGGKK...........
............KKGGGGGGGGGGGGKTTTTTTTTTTKGGGGGGGGGGGGGKK...........
............KKGGGGGGGGGGGGKTTTTTTTTTTKGGGGGGGGGGGGGKK...........
............KKGGGGGGGGGGGGKTTTTTTTTTTKGGGGGGGGGGGGGKK...........
.....KKKKKKKKGGGGGGGGGGGGGKTTTTTTTTTTKGGGGGGGGGGGGGGKKKKKKK.....
.....KaaaaaaKKGGGGGGGGGGGGKTTTTTTTTTTKGGGGGGGGGGGGGKKaaaaaK.....
.....KaaaaaaKKGGGGGGGGGGGGKTTTTTTTTTTKGGGGGGGGGGGGGKKaaaaaK.....
.....KaaaaaaKKGGGGGGGGGGGGKKKKKKKKKKKKGGGGGGGGGGGGGKKaaaaaK.....
.....KaaaaaaKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKaaaaaK.....
.....KaaaaaaaKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKaaaaaaK.....
.....KaaaaaaaKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKaaaaaaK.....
.....KaaaaaaaaKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKaaaaaaaK.....
.....KaaaaaaaaKKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKKaaaaaaaK.....
.....KaaaaaaaaaKKKGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKKaaaaaaaaK.....
.....KaaaaaaaaaaKKKGGGGGGGGGGGGGGGGGGGGGGGGGGGKKKaaaaaaaaaK.....
.....KaaaaaaaaaaaKKKKGGGGGGGGGGGGGGGGGGGGGGGKKKKaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaKKKKGGGGGGGGGGGGGGGGGGGKKKKaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaKKKKKGGGGGGGGGGGGGGGKKKKKaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaKKKKKKKKKKGKKKKKKKKKKaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaKKKKKKKKKKKKKKKaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBKBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaNNNNNNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNNNNNNaaaK.....
.....KaaaNTTTTNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNTTTTNaaaK.....
.....KaaaNTTTTNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNTTTTNaaaK.....
.....KaaaNTTTTNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNTTTTNaaaK.....
.....KaaaNTTTTNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNTTTTNaaaK.....
.....KaaaNTTTTNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNTTTTNaaaK.....
.....KaaaNTTTTNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNTTTTNaaaK.....
.....KaaaNNNNNNaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaNNNNNNaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KaaaaaaaaaaaaaaaaaaaNBBBBBBBBBBBBNaaaaaaaaaaaaaaaaaaaK.....
.....KKKKKKKKKKKKKKKKKKKKNNNNNNNNNNNNNNKKKKKKKKKKKKKKKKKKKK.....
`,
  ),
  'spike-ball': parseSprite(
    16,
    `
................
........w.......
........K.......
...w...KKK...w..
....w.KKVKK.w...
.....KKVVVKK....
....KKVVTVVKK...
...KKVVTTTVVKK..
.wKKVVTTTTTVVKKw
...KKVVTTTVVKK..
....KKVVTVVKK...
.....KKVVVKK....
....w.KKVKK.w...
...w...KKK...w..
........K.......
........w.......
`,
  ),
  'fire-bar': parseSprite(
    16,
    `
................
........K.......
.......KKK......
......KKNKK.....
.....KKNNNKK....
....KKNNONNKK...
...KKNNOOONNKK..
..KKNNOOOOONNKK.
.KKNNOOOOOOONNKK
..KKNNOOOOONNKK.
...KKNNOOONNKK..
....KKNNONNKK...
.....KKNNNKK....
......KKNKK.....
.......KKK......
........K.......
`,
  ),
}
